import Image from "next/image";
import { motion } from "motion/react";
import community from "../../assets/images/community.png";
import { scrollToElement } from "@/lib/utils";

const FooterCTA = () => {
  const buttonVariants = {
    initial: {
      backgroundColor: "#F6FA5E",
      scale: 1,
      transition: {
        duration: 0.3,
        ease: "easeInOut",
      },
    },
    hovered: {
      backgroundColor: "#8BD6ED",
      scale: 1.02,
      transition: {
        duration: 0.3,
        ease: "easeInOut",
      },
    },
  };

  const imageVariants = {
    initial: {
      scale: 1,
      transition: {
        duration: 0.3,
        ease: "easeInOut",
      },
    },
    hovered: {
      scale: 1.05,
      transition: {
        duration: 0.3,
        ease: "easeInOut",
      },
    },
  };

  return (
    <motion.div
      className="w-full max-w-[1400px] mx-auto rounded-[64px] h-fit lg:h-[470px] px-6 lg:px-32 py-8 lg:py-14 flex flex-col lg:flex-row items-center lg:justify-between cursor-pointer gap-8 lg:gap-0"
      variants={buttonVariants}
      initial="initial"
      whileHover="hovered"
      whileTap={{ scale: 0.98 }}
      onClick={() => scrollToElement("marketing-section")}
    >
      <div className="flex items-center lg:items-start flex-col text-center lg:text-left">
        <div className="text-[min(12vw,160px)] tracking-[-0.05em] font-editorial leading-none lg:leading-normal">
          Join Waitlist
        </div>
        <div className="font-editorial text-xl lg:text-4xl tracking-[-0.03em] mt-4 lg:-mt-8">
          Ready to obtain an <span className="font-bold">unfair</span>{" "}
          advantage?{" "}
        </div>
      </div>

      <motion.div
        variants={imageVariants}
        initial="initial"
        whileHover="hovered"
        className="h-[300px] w-[300px] mx-auto"
      >
        <Image
          src={community}
          alt="community"
          className="w-full object-contain"
        />
      </motion.div>
    </motion.div>
  );
};

export default FooterCTA;
